export default "__VITE_ASSET__Dxt5So5U__"